// StatusIndicator is now embedded inside InputBar.
// This component is kept for backwards-compatibility but renders nothing.
export default function StatusIndicator() {
  return null;
}
